import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CartCtx = createContext(null);
export const useCart = () => useContext(CartCtx);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('kanel_cart') || '[]'); } catch { return []; }
  });

  useEffect(() => { localStorage.setItem('kanel_cart', JSON.stringify(items)); }, [items]);

  const add = (item) => setItems((prev) => [...prev, { ...item, _k: Date.now() + Math.random() }]);
  const remove = (k) => setItems((prev) => prev.filter((i) => i._k !== k));
  const clear = () => setItems([]);

  const total = useMemo(() => items.reduce((s, i) => s + i.precioUnidad * i.cantidad, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.cantidad, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, clear, total, count }}>
      {children}
    </CartCtx.Provider>
  );
}
